import React from "react";
import { css } from "@emotion/react";
import ClipLoader from "react-spinners/ClipLoader";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: rgb(59, 94, 194);
`;

function App() {
  return (
    <div className="sweet-loading">
      <ClipLoader css={override} size={150} />
    </div>
  );
}

export default App;
